//////////////////////////////////////////////////////////
//                                                      //   
//  PARA CLIENTES:                                      //   
//                                                      //   
//  APARECE COMO VERSÃO DO HEADER COM O BOTÃO DE        //   
//  VOLTAR NO LUGAR DO INPUT PARA BUSCAR EM TODAS       //   
//  AS PÁGINAS COM EXCEÇÃO DA HOME                      //   
//                                                      //   
//  FUNCIONALIDADE: HEADER PARA                         //    
//    VOLTAR PARA A PÁGINA HOME                         //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/pages/checkout.js                                  //
//      frontend/src/pages/detalhe.js                                   //
//      frontend/src/pages/estoque_seguranca.js                         //
//      frontend/src/pages/interesses.js                                //
//      frontend/src/pages/pedidos_cliente.js                           //
//      frontend/src/pages/pedidos.js                                   //
//      frontend/src/pages/trocar_senha.js                              //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import Logo from './header/logo';
import Voltar from  './header/voltar';
import CarrinhoButton from  './header/carrinho_button';
import LoginButton from  './header/login_button';
import LogoutButton from  './header/logout_button';

import '../assets/css/local/header.css';


function ContinuarComprando() {

    // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
      // 'Logo' -> FOTO DO LOGO DA IMAGINARIUM
      // 'Voltar' -> BOTÃO QUE REDIRECIONA PARA A HOME
      // 'CarrinhoButton' -> ABRE ABA LATERAL DIREITA DE CARRINHO (CASO CLIENTE) E OPÇÕES DE PERFIL (CASO FRANQUEADO)
      // 'LoginButton' -> ÍCONE DE LOGIN QUE REDIRECIONA PARA A PÁGINA DE LOGIN E CRIAR USUÁRIO
      // 'LogoutBurron' -> ÍCONE DE LOGOUT QUE ABRE OPÇÕES DE PERFIL (CASO CLIENTE) E REALIZA LOGOUT (CASO FRANQUEADO)    

    return (
        <div>
            <div className="pb-3 border-header header-top">
                <div className="row col col-12 m-0 pt-3">          
                    <Logo />
                    <div class="col-xl-6 col-5">
                    <Voltar />
                    </div>
                    <CarrinhoButton />
                    <LoginButton />
                    <LogoutButton />
                </div>
            </div>      
        </div>
    );
  }

  export default ContinuarComprando;
  